import {
  SET_LOADING,
  SET_PERSONAL_INFO,
  SET_NOK_INFO,
  SET_GUARANTOR_INFO,
  CLEAR_AGENT_DETAILS,
  SET_UPLOADED_DOCS,
  INVALIDATE_UPLOADED_DOC
} from "../types/onBoarding";

const initialState = {
  personalDetails: null,
  NOKDetails: null,
  guarantorsDetail: null,
  documents: null,
  loading: false,
  uploadedDocs: {}
};

const onboardingInfo = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case SET_PERSONAL_INFO:
      return {
        ...state,
        loading: false,
        personalDetails: payload,
      };

    case SET_NOK_INFO:
      return {
        ...state,
        loading: false,
        NOKDetails: payload,
      };

    case SET_GUARANTOR_INFO:
      return {
        ...state,
        loading: false,
        guarantorsDetail: payload,
      };

    case CLEAR_AGENT_DETAILS:
      return {
        ...initialState,
      };

    case SET_UPLOADED_DOCS:
      return {
        ...state, uploadedDocs: payload
      };

    case INVALIDATE_UPLOADED_DOC: 
    const newPayload = { ...state.uploadedDocs }

    newPayload[payload.name] = payload.value

      return {
        ...state, uploadedDocs: newPayload 
      }

    default:
      return state;
  }
};

export default onboardingInfo;
